import { TimeMeasurementValue } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { formatMinutes } from 'src/exShared/util/report/formatMinutes'
import { CellInner, TableBodyCellWrapper } from './Common.dumb'

type Props = {
  value?: TimeMeasurementValue
}

export const TableBodyCellTimeMeasurement: FC<Props> = ({ value }) => {
  return (
    <TableBodyCellWrapper
      backgroundColor={value?.isInvalid ? 'invalid' : 'fixed'}
      fontColor={value?.isInvalid ? 'invalid' : 'default'}
    >
      <CellInner>{formatMinutes(value?.value || 0)}</CellInner>
    </TableBodyCellWrapper>
  )
}
